import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup } from '@ngneat/reactive-forms';
import { BehaviorSubject, Subject, Observable } from 'rxjs';
import { map, skipWhile } from 'rxjs/operators';
import { HttpApiService } from '../services/http-api.service';
import { noWhitespaceValidator } from '../utils/functions/no-whitespace';
import { PageModel } from '../utils/interfaces/page-model';
import { Pagination } from '../utils/interfaces/pagination';

@Injectable({
  providedIn: 'root',
})
export class MemberService {
  private memberDetail$ = new BehaviorSubject<Member>(null);
  updateMemberDetail$ = new Subject<any>();

  constructor(private http: HttpApiService, private ngFb: FormBuilder) {}

  getMemberDetail() {
    return this.memberDetail$.pipe(skipWhile((val) => !val));
  }

  setMemberDetail(data: Member) {
    return this.memberDetail$.next(data);
  }

  getCreditProvider(member_id: number, agent_id: number) {
    return this.http.get<ICreditTranfer>(
      `api/v2/credit/wallet/provider?member_id=${member_id}&agent_id=${agent_id}`
    );
  }

  moveCreditMmeber(member_id: number, agent_id: number, value) {
    return this.http.post<any>(
      `api/v2/credit/transfer?member_id=${member_id}&agent_id=${agent_id}`,
      value
    );
  }

  /**
   * get Members
   * @param params PageModel, ?ask4betAgentId={ask4betAgentId}&status={status}
   * @returns observable Pagination Members
   */
  getMembers(params: PageModel) {
    return this.http.get<Pagination<Member[]>>(`api/member/pagination`, { params }).pipe(
      map((res) => {
        res.items = res.items.map((item) => {
          item.wallet_total =
            item.wallet +
            (item.memberAskmebet?.credit || 0) +
            (item.memberGclub?.credit || 0) +
            (item.memberBethub?.credit || 0) +
            (item.memberUfa?.credit || 0) +
            (item.wallet_seamless || 0);
          return item;
        });
        return res;
      })
    );
  }
  getProfileMember(id: number) {
    return this.http.get<IMemberOutstanding>(`v2/ag/member/profile?member_id=${id}`);
  }
  getTransferCreditLog(value: any) {
    return this.http.get<any>(`api/v2/credit/transfer/log`, { params: value });
  }
  getWinLoseOutStanding(params: any) {
    return this.http.get<IWinLoseOutstanding>(`v2/ag/member/winlose-outstanding`, { params });
  }
  getMemberById(id: number) {
    return this.http.get<Member>(`api/member?member_id=${id}`);
  }
  getMemberByIdNotUpdate(id: number) {
    return this.http.get<Member>(`api/member/not-update?member_id=${id}`);
  }

  create(value, agentId: number) {
    return this.http.post(`api/member?agent_id=${agentId}&ip_address=`, value);
  }

  edit(value, memberId: number) {
    return this.http.put(`api/member/edit?member_id=${memberId}`, value);
  }

  /**
   * @param status member type
   * @param params with pageModel and member_id
   * @returns observer
   */
  putMemberStatus(status: MemberType, params: PageModel) {
    return this.http.put<Pagination<Member[]>>(`api/member/status/${status}`, {}, { params });
  }

  confirm(memberId: number) {
    return this.http.put(`api/member/status/confirmed?member_id=${memberId}`, {});
  }

  suspend(memberId: number) {
    return this.http.put(`api/member/status/suspend?member_id=${memberId}`, {});
  }

  lock(memberId: number) {
    return this.http.put(`api/member/status/lock?member_id=${memberId}`, {});
  }

  /**
   * @param params member_id=${member_id}
   * @returns
   */
  getWinLose(params: PageModel) {
    return this.http.get<Pagination<MemberWinLose[]>>(`api/ask4bet/winlose/history/login_game`, {
      params,
    });
  }

  getWithdrawTurnover(member_id: number) {
    return this.http.get<WithdrawTurnover>(
      `api/ask4bet/withdraw/before_withdraw?member_id=${member_id}`
    );
  }

  deleteMember(member_id: number) {
    return this.http.delete(`api/member/status/remove?member_id=${member_id}`);
  }

  returnCreditToMember(member_id: number) {
    return this.http.post(`api/ask4bet/withdraw/amb/manual?member_id=${member_id}`, {});
  }

  editWallet(member_id: number, wallet: number) {
    return this.http.put(`api/member/edit/wallet?member_id=${member_id}`, { wallet });
  }

  postResetPassword(model: MemberResetPasswordModel) {
    return this.http.post(`api/member/reset_password`, model);
  }

  get createMemberResetPassword(): FormGroup<MemberResetPasswordModel> {
    return this.ngFb.group({
      member_id: [null],
      new_password: ['', [noWhitespaceValidator]],
      confirm_password: ['', [noWhitespaceValidator]],
    });
  }

  putClearTurnover(member_id: number) {
    return this.http.put(`api/member/clear_turnover?member_id=${member_id}`, {});
  }

  putClearTurnDeposit(member_id: any, deposit_id: any) {
    return this.http.put(
      `api/member/clear_turnover/per_deposit?member_id=${member_id}&deposit_id=${deposit_id}`,
      {}
    );
  }

  getStatusGameAMB(username: string): Observable<IRootGetStatusGameAMB> {
    return this.http.get(`api/ask4bet/amb/get/status_amb?username=${username}`);
  }
  ChangeStatusGameAMB(username: string, payload: IModelChangeStatus) {
    return this.http.put(`api/ask4bet/amb/get/chang_amb?username=${username}`, payload);
  }

  putClearTransactionTemp(member_id: number) {
    return this.http.put(`api/transaction/clear/transaction_temp?member_id=${member_id}`, {});
  }

  /**
   *
   * @param params member_id
   * @returns
   */
  getWinloseDetail(params: any) {
    return this.http.get(`v2/ag/winlose/detail`, { params });
  }
  getWinloseDetailGame(betId: string, game_type: string) {
    return this.http.get(`v2/ag/winlose/detail/${game_type}`, {
      params: {
        betId: betId,
      },
    });
  }
  getWinloseDetailGameCard(betId: string) {
    return this.http.get(`v2/ag/winlose/detail/game-card`, {
      params: {
        betId: betId,
      },
    });
  }
  getWinloseDetailCasino(betId: string) {
    return this.http.get(`v2/ag/winlose/detail/casino`, {
      params: {
        betId: betId,
      },
    });
  }
  getBetReplay(value: any) {
    return this.http.post(`v2/ag/action/bet-replay`, value);
  }

  putMemberBetlimitSetting(member_id: number, agent_id: number) {
    return this.http.put(
      `api/member/bet_limit/clone?member_id=${member_id}&agent_id=${agent_id}`,
      {}
    );
  }

  // -------------------------------- Version 2 --------------------------------
  preloadCreateMember(agent_code: string) {
    return this.http.get(`v2/ag/preload/create-member?agent_code=${agent_code}`);
  }
  preloadUpdateMember(agent_code: string, member_id: number) {
    return this.http.get(
      `v2/ag/preload/update-member?agent_code=${agent_code}&member_id=${member_id}`
    );
  }
  createMember(value: any) {
    return this.http.post(`v2/ag/create-member`, value);
  }
  updateMember(value: any, member_id: number) {
    return this.http.put(`v2/ag/update-member?member_id=${member_id}`, value);
  }
  cloneSettingMember(value: any, agent_code: string, member_id_to) {
    return this.http.post(
      `v2/ag/clone-setting?agent_code=${agent_code}&member_id_to=${member_id_to}`,
      value
    );
  }

  postSetCredit(model: any) {
    return this.http.post(`v2/ag/member/set-credit`, model);
  }

  getGameSession(member_id: number) {
    return this.http.post<IGameSession[]>(`v2/ag/member/get-session-game?member_id=${member_id}`, {});
  }
}

export interface IWinLoseOutstanding {
  wl: mWl[];
  outstanding: mOutstanding[];
}

export interface mWl {
  game_type: string;
  amount: number;
  valid_amount: number;
  winlose: number;
}

export interface mOutstanding {
  game_type: string;
  amount: number;
}

export interface IModelChangeStatus {
  suspend: boolean;
  lock: boolean;
  active: boolean;
}

export interface ICreditTranfer {
  credit: number;
  provider_transfer: ProviderTransfer[];
}

export interface ProviderTransfer {
  provider: string;
  credit: number;
}

export interface MemberModel {
  phone: string;
  password?: string;
  first_name: string;
  last_name: string;
  bank_number: string;
  bank: string;
  wallet: number;
  member_recommended_username: string;
  promotion_id: number;
  deposit_statement_id: number;
  datetime: string;
  image_statement: string;
  know_by_id: any;

  agent_id?: number;
}

export interface Member {
  id: number;
  username: string;
  phone: string;
  currency: string;
  first_name: string;
  last_name: string;
  fullname: string;
  bank_number: string;
  bank: string;
  bank_code: string;
  bank_name: string;
  bank_image?: any;
  register_date: string;
  register_ip: string;
  register_device: string;
  login_ip: string;
  last_login: string;
  login_device: string;
  wallet: number;
  wallet_outstanding: number;
  wallet_total: number;
  wallet_seamless: number;
  deposit_amount: number;
  deposit_amount_bonus: number;
  deposit_sum: number;
  deposit_sum_bonus: number;
  withdraw_amount: number;
  withdraw_sum: number;
  recommend_total: number;
  recommend_point: number;
  recommend_transfer: number;
  recommend_downline_total: number;
  status: MemberType;
  create_by?: any;
  update_date: string;
  update_by?: any;
  know_by_id: number;
  know_by: string;
  agent_id: number;
  agent_name: string;
  typeAgent: number;
  session_id: string;
  link_name?: any;
  code_aff?: any;
  link_affiliate_id?: any;
  user_aff_username?: any;
  user_affiliate_id?: any;
  current_game: string;
  memberAskmebet?: MemberAskmebet;
  memberKlotto?: MemberKlotto;
  memberGclub?: MemberGclub;
  memberBethub?: MemberBethub;
  memberUfa?: MemberUfa;
  memberSuperlot?: MemberSuperlot;
  loyalty: Loyalty;
  line?: any;

  first_deposit?: Firstdeposit;
}

interface MemberSuperlot {
  Id: number;
  member_id: number;
  superlot_member_id: number;
  username: string;
  password: string;
  credit: number;
  create_dt: string;
}

interface MemberUfa {
  Id: number;
  member_id: number;
  username: string;
  password: string;
  credit: number;
}

interface Loyalty {
  memberId: number;
  point_alltime: number;
  point_current: number;
  update_by?: any;
  update_dt?: any;
}

interface MemberBethub {
  Id: number;
  credit: number;
  member_id: number;
  password: string;
  username: string;
}

interface MemberGclub {
  Id: number;
  member_id: number;
  gclub_setting_id: number;
  username: string;
  password: string;
  credit: number;
}

export interface IMemberOutstanding {
  username: string;
  name: string;
  last_login: string;
  login_device: string;
  login_ip: string;
  register_dt: string;
  register_ip: string;
  register_device: string;
  credit: number;
  outstanding: Outstanding;
}

export interface Outstanding {
  sport: number;
  casino: number;
  slot: number;
  esports: number;
  lotto: number;
  keno: number;
  gamecard: number;
  cockfight: number;
  trading: number;
}

interface MemberKlotto {
  member_id: number;
  setting_id: number;
  klotto_member_id: string;
  username: string;
  password: string;
  credit: number;
}

interface MemberAskmebet {
  member_id: number;
  amb_member_id: string;
  setting_id: number;
  username: string;
  password: string;
  credit: number;
}

export interface Firstdeposit {
  Id: number;
  member_id: number;
  promotion_id?: number;
  agent: number;
  account_bank_agent_id?: number;
  credit_before: number;
  amount: number;
  amount_bonus: number;
  amount_total: number;
  credit_after: number;
  credit_agent_before: number;
  credit_agent_after: number;
  stack_other_pro?: boolean;
  reduce_credit_when_withdrawing?: boolean;
  winlose_amount?: any;
  member_id_recommend?: any;
  withdraw_then: boolean;
  note: string;
  datetime: string;
  image_statement: string;
  deposit_statement_id: number;
  create_date: string;
  update_by: number;
  update_date: string;
  is_bonus: boolean;
  is_manual: boolean;
  turn_over: number;
  max_withdraw: number;
  can_withdraw: boolean;
  turn_over_sport: boolean;
  turn_over_casino: boolean;
  turn_over_poker: boolean;
  turn_over_slot: boolean;
  turn_over_keno: boolean;
  turn_over_lotto: boolean;
  turn_over_trading: boolean;
  amount_can_be_withdraw: number;
  deposit_type: string;
  status: string;
  check_by?: any;
  check_date?: any;
  ref_amb: string;
  promotion_new_member: boolean;
  get_to_know_id?: any;
}

export enum MemberTypes {
  active = 'active',
  confirmed = 'confirmed',
  suspend = 'suspend',
  lock = 'lock',
}

export type MemberType = keyof typeof MemberTypes;

export interface MemberStatusPageModel extends Partial<PageModel> {
  status?: MemberType;
  member_id?: number;
}

export interface MemberWinLose {
  Id: number;
  member_id: number;
  ask4betAgentId: number;
  log_transaction: number;
  username: string;
  ref: string;
  credit_tranfer: number;
  game_list_name: string;
  game_name: string;
  amount: number;
  valid_amount: number;
  wl_amount: number;
  wl_turn_amount: number;
  outstanding: number;
  create_dt: string;
  login_game: string;
  logout_game: string;
  ref_dt: string;
  game_type: string;
  provider: string;
  status: string;
}

export interface MemberResetPasswordModel {
  member_id: number;
  new_password: string;
  confirm_password?: string;
}

export interface WithdrawTurnover {
  promotion_used: TurnoverPromotion[];
  turnover_amount: number;
  played: number;
  should_play: number;
}

export interface TurnoverPromotion {
  deposit_id: number;
  credit_can_not_withdraw: number;
  can_withdraw: boolean;
  promotion_id?: number;
  promotion_name: string;
  game: string[];
  promotion_turnover: number;
  promotion_can_be_withdraw: number;
  winlose_complete: boolean;
  winlose_amount: number;
}

export interface IReturnCreditMember {
  Id: number;
  member_id: number;
  admin_id?: any;
  amount: number;
  credit_from_before: number;
  credit_from_after: number;
  credit_to_before: number;
  credit_to_after: number;
  action: string;
  create_date: Date;
  _ref?: any;
  ip_address: string;
  browser: string;
  from_system: string;
  to_system: string;
  game_list_id?: any;
  game_list_name?: any;
  game_id?: any;
  game_name?: any;
  game_type?: any;
  provider: string;
  wallet_type: string;
  description: string;
  get_winlose: boolean;
  ref_transaction: number;
  status: string;
}

export interface SportsBook {
  isEnable: boolean;
}

export interface Parlay {
  isEnable: boolean;
}

export interface Step2 {
  isEnable: boolean;
}

export interface Step {
  parlay: Parlay;
  step: Step2;
}

export interface Sexy {
  isEnable: boolean;
}

export interface Ag {
  isEnable: boolean;
}

export interface Sa {
  isEnable: boolean;
}

export interface Dg {
  isEnable: boolean;
}

export interface Pt {
  isEnable: boolean;
}

export interface Ab {
  isEnable: boolean;
}

export interface Eb {
  isEnable: boolean;
}

export interface Cr {
  isEnable: boolean;
}

export interface Pm {
  isEnable: boolean;
  limit: number;
}

export interface Bg {
  isEnable: boolean;
  limit: number;
}

export interface Bt {
  isEnable: boolean;
  limit: number;
}

export interface Gd {
  isEnable: boolean;
  limit: number;
}

export interface Gc {
  isEnable: boolean;
  limit: number;
}

export interface Casino {
  sexy: Sexy;
  ag: Ag;
  sa: Sa;
  dg: Dg;
  pt: Pt;
  ab: Ab;
  eb: Eb;
  cr: Cr;
  pm: Pm;
  bg: Bg;
  bt: Bt;
  gd: Gd;
  gc: Gc;
}

export interface Amb {
  isEnable: boolean;
}

export interface Multi {
  amb: Amb;
}

export interface SlotXO {
  isEnable: boolean;
}

export interface Game {
  slotXO: SlotXO;
}

export interface M2 {
  isEnable: boolean;
}

export interface Tg {
  isEnable: boolean;
}

export interface Hg {
  isEnable: boolean;
}

export interface Es {
  isEnable: boolean;
}

export interface Other {
  m2: M2;
  tg: Tg;
  hg: Hg;
  es: Es;
}

export interface Amb2 {
  isEnable: boolean;
}

export interface Pp {
  isEnable: boolean;
  hour: number;
  minute: number;
}

export interface Laos {
  isEnable: boolean;
}

export interface Stock {
  isEnable: boolean;
}

export interface Lotto {
  amb: Amb2;
  pp: Pp;
  laos: Laos;
  stock: Stock;
}

export interface Og {
  isEnable: boolean;
}

export interface Poker {
  og: Og;
}

export interface LimitSetting {
  sportsBook: SportsBook;
  step: Step;
  casino: Casino;
  multi: Multi;
  game: Game;
  other: Other;
  lotto: Lotto;
  poker: Poker;
}

export interface Result {
  limitSetting: LimitSetting;
  suspend: boolean;
  lock: boolean;
  active: boolean;
}

export interface IRootGetStatusGameAMB {
  result: Result;
  code: number;
  message: string;
  url?: any;
  path?: any;
}

export interface IGameSession {
	username: string;
	game_session_id: string;
	member_id: number;
	agent_id: number;
	game_provider: string;
	game_code_or_productId: string;
	game_list_code: string;
	gpid: number;
	token_session: string;
	superapi_session: string;
	superapi_sexy_userId: string;
	tfgaming_session?: any;
	win568_session?: any;
	win568_product_type: number;
	session_ip: string;
	platform: string;
	percent_agent: number;
	percent_agent_id?: any;
	percent_master: number;
	percent_master_id?: any;
	percent_senior: number;
	percent_senior_id?: any;
	percent_shareholder: number;
	percent_shareholder_id: number;
	percent_system: number;
	percent_provider: number;
	update_dt: string;
	create_dt: string;
	sys_game_name: string;
	sys_game_image: string;
	sys_game_image_preview: string;
	sys_game_list_name: string;
	sys_game_list_image: string;
	sys_game_list_image_preview: string;
}
